export { default } from './UserMessageActions.component';
export type { UserMessageActionsProps } from './UserMessageActions.component';
